<div id="email-warning" class="esf-notification esf-notification--warning is-active" *ngIf="opened"
     style="position: fixed;
     z-index: 101;
     top: 0;
     left: 0;
     right: 0;">
  <div class="esf-container">
    <span i18n='@@customerOverview.notification.customerEmailWarning'>
      This customer currently does not have an email address.
    </span>
  </div>
  <div class="esf-notification__close">
    <svg class="esf-icon esf-icon--white" width="16" height="16" (click)="close()">
      <use xlink:href="#esf-icon-close"></use>
    </svg>
  </div>
</div>
